import { Link } from "../app/router";
import { assetUrl } from "../lib/asset";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link className="brand" to="/" aria-label="Rêu Nắng — về trang chủ">
      <img src={assetUrl("/media/logo-mark.svg")} width="44" height="44" alt="" />
      {!compact && (
        <span>
          <strong>Rêu Nắng</strong>
          <small>ban công sống khỏe</small>
        </span>
      )}
    </Link>
  );
}
